import { EnvelopesQuery, getEnvelopesQuery } from '../../../queries';

export const EnvelopesEndpoints = {
    data: (doneeId: number, query: EnvelopesQuery) =>
        `/donees/${doneeId}/envelopes/altindex${getEnvelopesQuery(query)}`,
};
